
export default {
  appEnv: 'local',
  apiUrl: `http://localhost:20000/api/`,
  downloadUrl: `http://localhost:20000/`,
};
